<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Reporte áreas comunes</strong>
        </h2>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;">
            <span class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; display: table; margin: 0 auto;">Visitas
              registradas</span>

            <div class="text-right" style="margin-top: -10px; display: flex; float: right;">

              <mdb-popover
                trigger="click"
                placement="bottom"
                :options="{ boundary: 'window' }"
              >
                <!-- Contenido del menú -->
                <div slot="body" class="d-flex flex-column">
                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('xlsx')"
                  >
                    <mdb-icon icon="file-excel" class="mr-2" />
                    Excel (.xlsx)
                  </mdb-btn>

                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('csv')"
                  >
                    <mdb-icon icon="file-alt" class="mr-2" />
                    CSV (.csv)
                  </mdb-btn>
                </div>

                <!-- Botón único -->
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 style_BTN"
                >
                  <mdb-icon icon="download" />
                </mdb-btn>

              </mdb-popover>

            </div>




          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-left" responsive>
                  <tr>
                    <th scope="col">
                      Residente
                      <p>
                        <input type="text" style="width: 85% !important;" class="inputClass" v-model="searchResident"
                          @input="getVisitats" placeholder="Buscar residente" />
                      </p>
                    </th>
                    <th scope="col">
                      Invitado
                      <p>
                        <input type="text" style="width: 85% !important;" class="inputClass" v-model="searchVisitant"
                          @input="getVisitats" placeholder="Buscar invitado" />
                      </p>
                    </th>
                    <th scope="col">
                      Fecha de ingreso <mdb-date-picker id="timein" outline placeholder="Buscar f. de ingreso"
                        :option="optionsDate" v-model="dateTimeIn" :limit="limitDate" style="width: 90% !important;
                            margin-top: -20px;
    margin-bottom: -10px;" />
                    </th>
                    <th scope="col">
                      Área común
                      <p>
                        <input type="text" style="width: 85% !important;" class="inputClass"
                          placeholder="Buscar área común" v-model="searchArea" @input="getVisitats" />
                      </p>
                    </th>
                    <th scope="col">
                      Modo de ingreso
                      <p>
                        <model-select :options="TypesList" v-model="typesModel" @input="getVisitats"
                          placeholder="Seleccionar QR/Manual"
                          style="width: 10rem !important;height: 0rem !important; font-size: 11px;"></model-select>
                      </p>
                    </th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body class="text-left" style="font-size: 8px !important;">
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td v-if="item.resident">
                      <span>{{ item.resident.firstName + ' ' + item.resident.lastName }}</span>
                      <p v-show="isMe.frac == 'Club Tres Marias'">Acción: {{ item.resident.action }}</p>
                      <p>Calle: {{ item.resident.testStreet.name + ' #' + item.resident.number }}</p>
                      <p>Zona: {{ item.resident.testStreet.testZone.name }}</p>
                    </td>
                    <td v-else>SIN REGISTRO</td>
                    <td v-if="item.firstName && item.lastName"> <mdb-icon icon="user-circle" class="mt-0" />{{
                      ' ' + item.firstName + ' ' + item.lastName }}
                      <div v-if="item.file">
                        <div @click="showPhoto(item.file.publicUrl)" style="color: #3c8dbc; cursor: pointer;">
                          Identificación</div>
                      </div>
                      <div v-else> Identificación No Registrada </div>
                    </td>
                    <td v-else>SIN REGISTRO</td>
                    <td v-if="item.timein"><span>
                        <mdb-icon icon="calendar-alt" class="mt-0" />
                        {{ dateIn(item.timein) }}
                      </span>
                      <p>
                        <mdb-icon icon="clock" class="mt-0" />
                        {{ timeIn(item.timein) }}
                      </p>
                    </td>
                    <td v-else> <mdb-icon icon="calendar-times" class="mt-0" /> SIN REGISTRO</td>
                    <td> <mdb-icon icon="tree" />{{ ' ' + item.commonArea.name }}</td>
                    <td v-if="item.createdWithQR">Qr</td>
                    <td v-else>Manual</td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />

            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>

    <Loader v-show="isLoading" />
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import XLSX from "xlsx";
import { ModelSelect } from "vue-search-select";
import Loader from "../../core/Loader"
import { mapGetters, mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbPopover,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";

export default {
  name: "Visitants",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbPopover,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    ModelSelect,
    Loader,
    Pagination,
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      visitantsList: [],
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      isLoading: true,
      gateName: "",
      whoami: [],
      TitleModal: "Agregar",
      gate: [],
      searchResident: "",
      searchVisitant: "",
      dateTimeIn: null,
      dateSearch: "",
      dateTimeOut: null,
      dateSearchOut: "",
      searchArea: "",
      TypesList: [
        {
          value: "",
          text: "Todos"
        },
        {
          value: "qr",
          text: "Qr"
        },
        {
          value: "manual",
          text: "Manual"
        },

      ],
      typesModel: {
        value: "",
        text: ""
      },
      optionsDate: {
        week: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
        month: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        buttons: {
          ok: "Aceptar",
          clear: "Limpiar",
          cancel: "Cancelar",
          today: "Hoy"
        },
        format: "DD-MM-YYYY"
      },
      limitDate: [
        {
          type: "fromto",
          from: "",
          to: "2100-12-30"
        }
      ],
      listFilter: [],
    };
  },
  methods: {
    ...mapActions(["getReportCommonArea"]),
    // dateIn(date) {
    //   var d = new Date(date);
    //   var today = new Date(d.getTime());
    //   var dd = today.getDate();
    //   var mm = today.getMonth() + 1;

    //   var yyyy = today.getFullYear();
    //   if (dd < 10) {
    //     dd = "0" + dd;
    //   }
    //   if (mm < 10) {
    //     mm = "0" + mm;
    //   }
    //   var today = dd + "/" + mm + "/" + yyyy;
    //   return today;
    // },
    // timeIn(date) {
    //   var d = new Date(date);
    //   return d.toLocaleTimeString();
    // },

    getActiveTimeZone() {
      return (this.isMe && this.isMe.fracTimeZone) || undefined;
    },

    parseToUTCDate(value) {
      if (value == null) return null;
      if (typeof value === 'number') {
        // soporta epoch en segundos o milisegundos
        return value < 1e12 ? new Date(value * 1000) : new Date(value);
      }
      if (typeof value === 'string') {
        let v = value.trim();
        // si viene sin zona (sin 'Z' ni +hh:mm), lo tratamos como UTC
        const hasZone = /[zZ]|[+\-]\d{2}:\d{2}$/.test(v);
        if (!hasZone) v += 'Z';
        return new Date(v);
      }
      try { return new Date(value); } catch { return null; }
    },

    dateIn(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        day: '2-digit', month: '2-digit', year: 'numeric'
      }).format(d);
    },

    timeIn(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).format(d);
    },

    makeExcel(list) {
      var newList = [];
      for (let i = 0; i < list.length; i++) {
        let auxJson = {
          residente: list[i].resident
            ? list[i].resident.firstName +
            " " +
            list[i].resident.lastName +
            "\n Calle: " +
            list[i].resident.testStreet.name +
            " #" +
            list[i].resident.number +
            "\n Zona" +
            list[i].resident.testStreet.testZone.name
            : "SIN REGISTRO",
          invitado:
            list[i].firstName && list[i].lastName
              ? list[i].firstName + " " + list[i].lastName
              : "SIN REGISTRO",
          "Hora_estimada": list[i].estimatedTimeIn
            ? list[i].estimatedTimeIn
            : "SIN REGISTRO",
          "Hora_ingreso": list[i].timein ? list[i].timein : "Pendiente",
          "Area_comun": list[i].commonArea.name,
          "Modo_ingreso": list[i].createdWithQR ? "Qr" : "Manual"
        };
        newList.push(auxJson);
      }
      return newList;
    },
    async exportExcel() {
      let params = { body: "" };
      params.body = `resident=${this.searchResident}&invited=${this.searchVisitant}&timein=${this.dateTimeIn ? this.dateTimeIn : ''}&commonArea=${this.searchArea}&withQr=${this.typesModel.value}&isReport=true`
      try {
        this.isLoading = true;
        let response = await this.getReportCommonArea(params)
        const rows = response?.data

        if (!Array.isArray(rows) || rows.length === 0) {
          this.isLoading = false
          this.showMessageInfo(
            "Sin datos",
            "No hay visitas registradas para hoy.",
            "warning"
          )
          return
        }
        var dataTable = this.makeExcel(response.data);
        let data = XLSX.utils.json_to_sheet(dataTable);
        const workbook = XLSX.utils.book_new();
        const fileName = "reporte_areas_comunes";
        XLSX.utils.book_append_sheet(workbook, data, fileName);
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    exportFile(type) {
      if (type === 'xlsx') {
        this.exportExcel();
      } else {
        this.exportCsv();
      }
    },
    async exportCsv() {
      let params = { body: "" };
      params.body = `resident=${this.searchResident}&invited=${this.searchVisitant}&timein=${this.dateTimeIn ? this.dateTimeIn : ''}&commonArea=${this.searchArea}&withQr=${this.typesModel.value}&isReport=true`

      try {
        this.isLoading = true;
        let response = await this.getReportCommonArea(params)
        const rows = response?.data

        if (!Array.isArray(rows) || rows.length === 0) {
          this.isLoading = false
          this.showMessageInfo(
            "Sin datos",
            "No hay visitas registradas para hoy.",
            "warning"
          )
          return
        }
        var dataTable = this.makeExcel(response.data);
        let worksheet = XLSX.utils.json_to_sheet(dataTable);
        let csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "reporte_areas_comunes.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async getVisitats() {
      let params = { body: "" };
      params.body = `resident=${this.searchResident}&invited=${this.searchVisitant}&timein=${this.dateTimeIn ? this.dateTimeIn : ''}&commonArea=${this.searchArea}&withQr=${this.typesModel.value}&isReport=false`
      try {
        this.isLoading = true;
        let response = await this.getReportCommonArea(params)
        this.visitantsList = response.data
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },

    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showPhoto(url) {
      Swal.fire({
        title: 'Identificación',
        width: 550,
        padding: '3em',
        html: '<div<a data-caption="Image caption 1"  href="' + url + '"><img id="myimage" style="width: 100%;" src="' + url + '"></a></div>',
        showCancelButton: false,
        confirmButtonText: 'Cerrar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        reverseButtons: true,
        allowOutsideClick: false,
      })
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      this.getReportCommonArea(); // Llamada para actualizar los datos según la página seleccionada
    },
    showMessageInfo: function (text, subtitle, type = "warning") {
      Swal.fire({
        title: `<span style="font-size: 20px;">${text}</span>`,
        html: `<span style="font-size: 12px;">${subtitle}</span>`,
        icon: type, // ⬅️ SweetAlert2 usa icon, no type
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      })
    },
  },
  mounted() { },
  created() {
    this.getVisitats();
  },
  watch: {
    visitantsList() {
      //this.setPages();
    },
    dateTimeIn(value) {
      if (value) {
        var dd = value.slice(0, 2);
        var mm = value.slice(3, 5);
        var yyyy = value.slice(6, 10);
        this.dateSearch = yyyy + "-" + mm + "-" + dd;
        this.getVisitats();
      } else {
        this.dateSearch = "";
      }
    },
    dateTimeOut(value) {
      if (value) {
        var dd = value.slice(0, 2)
        var mm = value.slice(3, 5)
        var yyyy = value.slice(6, 10)
        this.dateSearchOut = yyyy + "-" + mm + "-" + dd;
      } else {
        this.dateSearchOut = "";
      }

    },
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
      userMe: "getUserInfo"
    }),
    displayedPost() {

      // if(this.searchResident){
      //   this.listFilter = this.listFilter.filter(item => {
      //     if(item.resident){
      //         var nameResident = item.resident.firstName+" "+item.resident.lastName;
      //         return (item.resident.firstName.toLowerCase().indexOf(this.searchResident.toLowerCase()) >= 0 ||
      //       item.resident.lastName.toLowerCase().indexOf(this.searchResident.toLowerCase()) >= 0 ||
      //       nameResident.toLowerCase().indexOf(this.searchResident.toLowerCase()) >= 0 );
      //     }

      //   })
      // }
      // if(this.searchVisitant){
      //   this.listFilter = this.listFilter.filter(item => {
      //     if(item.firstName && item.lastName){
      //       var nameVisitant = item.firstName+" "+item.lastName;
      //       return (item.firstName.toLowerCase().indexOf(this.searchVisitant.toLowerCase()) >= 0 ||
      //       item.firstName.toLowerCase().indexOf(this.searchVisitant.toLowerCase()) >= 0 || nameVisitant.toLowerCase().indexOf(this.searchVisitant.toLowerCase()) >= 0)
      //     }

      //   });
      // }
      // if(this.searchArea){
      //   this.listFilter = this.listFilter.filter(item => {
      //     return (item.commonArea.name.toLowerCase().indexOf(this.searchArea.toLowerCase()) >= 0)
      //   });


      // }

      // if(this.dateSearch){
      //   var date = new Date(this.dateSearch + "T00:00:00");
      //   var date2 = new Date(this.dateSearch + "T23:59:59");
      //   this.listFilter = this.listFilter.filter(item => {
      //     if(item.estimatedTimeIn){
      //         return (new Date(item.estimatedTimeIn) >= date && new Date(item.estimatedTimeIn) <= date2);

      //     }
      //   });
      // }
      // if(this.typesModel.value){
      //   this.listFilter = this.listFilter.filter(item => {
      //     if(this.typesModel.value == 1){
      //       return (
      //         item.createdWithQR
      //       )
      //     }else if( this.typesModel.value == 2){
      //       return (!item.createdWithQR)
      //     } else {
      //       return item
      //     }
      //   });

      // }
      this.listFilter = this.visitantsList;
      return this.paginate(this.listFilter)

    },

  }
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 12px;
  color: #495057;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #495057;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #495057;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table>tbody {
  text-align: left;
}

.table td {
  font-size: 13px !important;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}


.inputClass {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #dadce0;
  border-radius: 4px;
  background-color: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 2rem;
}
</style>

<style></style>